import React from 'react';
const ErrorMessage = React.forwardRef((props, ref) => {
    return (
        <li className="error-message-list-item" tabIndex="0" ref={ref}>
            <span className="fa-stack fa-lg icon">
                <i className="fa fa-circle fa-stack-1x" aria-hidden="true"></i>
                <i className="fa fa-exclamation-circle fa-stack-1x red-exclamation" aria-hidden="true"></i>
            </span>
            {props.message}
        </li>
    );
})
export default ErrorMessage;
